/*! @azure/msal-react v3.0.21 2025-10-29 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "3.0.21";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
